import React from 'react'
import { getParentNotificationIcon } from '../../data/parentNotificationIcons'
import s from './RuleList.module.scss'

export const RuleRow = ({ rule, onToggleRule, togglingCode, prefsBusy }) => {
	const RuleIcon = getParentNotificationIcon(rule.icon)
	const StatusIcon = getParentNotificationIcon(rule.enabled ? 'check_circle' : 'pause')
	const isToggling = togglingCode === rule.code || togglingCode === rule.id
	const toggleDisabled = Boolean(prefsBusy)

	return (
		<article className={s.rule}>
			<span className={`${s.rule__icon} ${s[`rule__icon--${rule.tone || 'purple'}`]}`.trim()}>
				<RuleIcon aria-hidden />
			</span>
			<div className={s.rule__copy}>
				<div className={s.rule__titleWrap}>
					<strong className={s.rule__title}>{rule.name}</strong>
				</div>
				<span className={s.rule__description}>{rule.description}</span>
			</div>
			<span
				className={`${s.rule__status} ${rule.enabled ? s['rule__status--active'] : s['rule__status--paused']}`}
			>
				<StatusIcon aria-hidden />
				{rule.enabled ? 'Active' : 'Paused'}
			</span>
			<div className={s.rule__actions}>
				<button
					type="button"
					className={`${s.rule__toggle} ${rule.enabled ? s['rule__toggle--active'] : ''}`}
					aria-pressed={rule.enabled}
					aria-label={`${rule.enabled ? 'Pause' : 'Enable'} ${rule.name}`}
					aria-busy={isToggling || undefined}
					disabled={toggleDisabled}
					onClick={() => onToggleRule(rule.code || rule.id)}
				>
					<span className={s.rule__toggleKnob} />
				</button>
			</div>
		</article>
	)
}

export const RuleList = ({ rules, onToggleRule, togglingCode, prefsBusy }) => (
	<>
		<div className={s.list__head}>
			<span className={s.list__headSpacer} aria-hidden />
			<span className={s.list__headCell}>Update</span>
			<span className={`${s.list__headCell} ${s.list__headCellStatus}`}>Status</span>
			<span className={s.list__headCell} aria-hidden />
		</div>
		<div className={s.list}>
			{rules.map(rule => (
				<RuleRow
					key={rule.code || rule.id}
					rule={rule}
					onToggleRule={onToggleRule}
					togglingCode={togglingCode}
					prefsBusy={prefsBusy}
				/>
			))}
		</div>
	</>
)

export default RuleList
